import i18n from '@app/i18n';
import { useHeader } from '@context/header';
import { ReactNode, useEffect } from 'react';

export const usePageTitle = (title: ReactNode) => {
  const { setTitle } = useHeader();

  useEffect(() => {
    setTitle(title);

    // Cleanup: reset to default when component unmounts
    return () => {
      setTitle(i18n.t('dashboard-page-title'));
    };
  }, [title, setTitle]);
};
